import api from '@/services/api'

const hasSuperRolePermission = async (availableToValuesMaster, withHasAdminAccess) => {
    let superRoles = ['god', 'administrator', 'local_administrator']

    if (availableToValuesMaster) superRoles.push('is_values_master')
    if (withHasAdminAccess) superRoles.push('has_admin_access')

    let hasSuperRolePermission = false

    await api
        .get('/users/current', {
            params: {
                append: 'has_roles',
            },
        })
        .then((resp) => {
            const {
                data: { data },
            } = resp

            hasSuperRolePermission =
                superRoles.filter((role) => {
                    return data.has_roles.includes(role)
                }).length > 0
        })
        .catch((e) => {
            console.log(e)
        })
    return hasSuperRolePermission
}

export const shallPass = async (next, withValuesMaster = false, withHasAdminAccess = false) => {
    const canPass = await hasSuperRolePermission(withValuesMaster, withHasAdminAccess)
    return canPass ? next() : next('/v2/home')
}
